import {
  AggregationResultAttributes, ContextResource, ResultResource, RangeDailyValue,
} from '@/api/v2/types/aggregation-result'
import { BusinessRuleResultAttrs } from '@/api/v2/report/BusinessRuleResult'

type AggregationId = number
type AggregationContainerAggregations = Record<AggregationId, AggregationResultAttributes>

export function useBusinessRuleResult(aggregations: AggregationContainerAggregations) {
  const updateAggregations = (refreshedResults: BusinessRuleResultAttrs[]) => {
    // 更新が必要なaggregationIdを特定
    const targetAggregationIds = new Set<AggregationId>()
    refreshedResults.forEach(result => {
      Object.keys(aggregations).forEach(aggregationId => {
        const aggregation = aggregations[Number(aggregationId)]
        const hasTargetContext = aggregation.contexts.data.some(
          (context: ContextResource) => context.attributes.contextType === result.contextType
            && context.attributes.id === result.contextId,
        )
        if (hasTargetContext) {
          targetAggregationIds.add(Number(aggregationId))
        }
      })
    })

    // 更新が必要なaggregationのみを処理
    targetAggregationIds.forEach(aggregationId => {
      const aggregation = aggregations[aggregationId]
      const newContexts = aggregation.contexts.data.map((context: ContextResource) => {
        const newResultsData = context.attributes.results.data.map((result: ResultResource) => {
          const matchedResult = refreshedResults.find(
            refreshedResult => refreshedResult.businessRuleId === result.attributes.businessRuleId
              && refreshedResult.contextType === context.attributes.contextType
              && refreshedResult.contextId === context.attributes.id,
          )

          if (matchedResult) {
            const { resultValue: newVal, businessDate: newDate, id: newResId } = matchedResult
            const { value } = result.attributes
            if (Array.isArray(value)) {
              const newDailyArray = value.map((d: RangeDailyValue) => {
                if (d.date === newDate) {
                  return {
                    ...d,
                    value: newVal,
                    businessRuleResultId: newResId,
                  }
                }

                return d
              })

              return {
                ...result,
                attributes: {
                  ...result.attributes,
                  value: newDailyArray,
                },
              }
            }
          }

          return result
        })

        return {
          ...context,
          attributes: {
            ...context.attributes,
            results: {
              ...context.attributes.results,
              data: newResultsData,
            },
          },
        }
      })

      // eslint-disable-next-line no-param-reassign
      aggregations[aggregationId] = {
        ...aggregation,
        contexts: {
          ...aggregation.contexts,
          data: newContexts,
        },
      }
    })
  }

  return {
    updateAggregations,
  }
}
